import { Link, useParams } from "react-router-dom";
import DataLoader from "../../Utils/DataLoader";
import {useState, useEffect, useMemo } from "react";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL } from "../../constants/matcher";
import { toast } from 'react-toastify';

const MatchMaking = () => 
{
    const [servantList, setServantList] = useStateWithCallbackLazy([]);
    const [selected, setSelected] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);

    const {user_id} = useParams();

    useEffect(() => 
    {
        const token = JSON.parse(localStorage.getItem("user-token"));
        const fetchData = async() => 
        {
            return await fetch(HTTPURL+'admin/mentors/match-making',{headers:{'Authorization' :`Bearer ${token}`}})
            .then(res => res.json())
            .then(data => {
                setServantList(data.data, () => setShowResults(true));
            });
        }
        fetchData();
    },[]);

    const defaultCheckList = async () => 
    {
        await fetch(HTTPURL+'admin/mentors/list-match-making',
        {
            headers: {"Content-Type": "application/JSON"}
        })
        .then(res => res.json())
        .then(data => 
        {
            setSelected([data.data]);
        })
        .catch(err => console.log(err)); 
    }

    // handle checked box
    const [demo, setDemo] = useStateWithCallbackLazy({
        id:'',
        status:false
    });
    const handleCheckbox = (servant_id) => (e) =>
    {
        let status = e.target.checked;
        setDemo({
            id:servant_id,
            status:status
        });
        const formData = {
            "mentor_id": user_id,
            "servant_id": servant_id,
            "status": status
        };

        fetch(HTTPURL+'admin/mentors/add-match-making',
        {
            method: "POST",
            headers: {"Content-Type": "application/JSON"},
            body: JSON.stringify(formData)
        }
        )
        .then(res => res.json())
        .then((data) => 
        {
            if(data.status === true)
            {
                toast.success(data.message);
            }else{
                toast.error(data.message);
            }
        })
        .catch(err => toast.error(err));
    }


    useEffect(() => 
    {
        defaultCheckList();
    },[demo]);


    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Servants List</h1>
                <ol className="breadcrumb mb-4">
                    <Link to="/secure/dashboard" className="breadcrumb-item">Dashboard</Link>
                    <Link to="/secure/mentors" className="breadcrumb-item ">Mentors</Link>
                    <Link className="breadcrumb-item active">Match Making</Link>
                </ol>
                {
                    showResults ? 
                    <div class="row">
                        {
                            servantList && servantList.map((val,index) =>
                            {
                                return(
                                    <div className="col-md-3" key={index}>
                                        <div className="custom-control custom-checkbox image-checkbox">
                                            <input type="checkbox" className="custom-control-input" 
                                                onChange={handleCheckbox(val.id)} id={index}
                                                checked={ selected[0]?.includes(val.id) ? true : demo.id == val.id && demo.status ? true:false} 
                                            />
                                            <label className="custom-control-label" for={index}>
                                                <img src={val.photo ? HTTPURL+'images/'+val.photo : HTTPURL+'images/default.png'} alt={val.photo ? val.photo : 'default.png'} title={val.firstName +' '+ val.lastName} class="img-fluid" />
                                            </label>
                                            <span className="text-center">{val.firstName +' '+ val.lastName}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <DataLoader />
                }
            </div> 
        </main>       
    )
}

export default MatchMaking;